// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

export class ContrastPoint {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
__init(i:number, bb:flatbuffers.ByteBuffer):ContrastPoint {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

from():number {
  return this.bb!.readUint16(this.bb_pos);
}

to():number {
  return this.bb!.readUint8(this.bb_pos + 2);
}

static sizeOf():number {
  return 4;
}

static createContrastPoint(builder:flatbuffers.Builder, from: number, to: number):flatbuffers.Offset {
  builder.prep(2, 4);
  builder.pad(1);
  builder.writeInt8(to);
  builder.writeInt16(from);
  return builder.offset();
}

}
